export default {
   'floorplanGuide': '3D展馆图',
   'floorplanGuideTips': '一键点击展位导航',
   'liveStream': '参展商直播',
   'featuredExhibitors': '特色展商',
   'bookingNow': '进入',
   'distanceFromLiveTime': {
      'time':'开播时间',
      'noStart':'已开播'
   },
   'viewProductLive':'浏览更多展品',
   'viewMoreLive':'观看更多直播',
   'exhTips':'多个供应商的快速报价',
   'youMayLike':'你可能喜欢',
   'concurrentEvents': '同期活动',
   'footerTitle1':'2020锦汉家居礼品展线上展',
   'footerTitle2':'快速链接:',
   'footerTitle3':'主办单位:',
   'footerTitle4':'2020年10月21~27日（UTC/GMT +8:00）',
   'footerQuickAccess1':'在线展厅',
   'footerQuickAccess2':'关于锦汉',
   'footerQuickAccess3':'如何到达',
   'footerQuickAccess4':'下载中心',
   'footerQuickAccess5':'隐私保护',
   'footerQuickAccess6':'站点地图',
   'newText1': '3D展位图',
   'newText2': '新闻中心',
   'newText3': '关于锦汉',
   'newText4': '联系我们',
   'newText5': '相关知识产权',
   'newText6':'APP 操作指南',
   'newText7':'网站操作指南',
   'footerComName':'广州市保利锦汉展览有限公司',
   'footerFax':'传真 : +86 (0)20 8989 9111',
   'footerTel':'电话 : +86 (0)20 8989 9633',
   'footerEmail':'邮箱 : info@jinhanfair.com',
   'footerAddress':'地点：广州保利世贸博览馆',
   'footerAddressTips':'（广交会C区B区对面）',
   'footerSocialMedia':'社交媒体',
   'exhibitor':'展商',
   'person':'观众',
   'Home': '首页',
   'Exhibitor': '找展商',
   'Products': '找展品',
   'Visitor':'找观众',
   'Business':'找商机',
   'Live':'直播',
   'About':'关于我们',
   'QA':'Q&A',
   'News': '新闻',
   'viewMoreNews': '浏览更多新闻',

   'download':'下载App',
   'searchPlaceHolder': '搜索'


}
  